import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'MenuDesktop' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 4
    }
});
